import React from "react";
import { Route, Routes } from "react-router-dom";
import RegistroEquiposPage from "../pages/RegistroEquiposPage";

export default function RegistroEquiposRoutes() {
  return (
    <Routes>
      <Route path="" element={<RegistroEquiposPage />} />
    </Routes>
  );
}
